// extracted by mini-css-extract-plugin
export default {"slider":"_1ytWw","slider-short":"_3N3mh","sliderShort":"_3N3mh","slider-adoptables":"_2JGs-","sliderAdoptables":"_2JGs-","slider-item":"_96JHc","sliderItem":"_96JHc"};